<template>
  <div :id="id" class="print-table">
    <div class="header">
      <div class="logo mb-1 flex align-center space-between">
        <img
          :src="userInfo && userInfo.bussinessLogoUrl"
          style="
            max-width: 15rem;
            min-height: 3rem;
            max-height: 4rem;
            min-width: 14rem;
          "
          alt="logo"
        />
        <img
          v-if="
            userInfo.tenantId === 1 &&
              isOther !== 'Laboratory' &&
              isOther !== 'Doctor' &&
              isOther !== 'Other'
          "
          :src="getBranchUrl"
          style="
            max-width: 15rem;
            min-height: 3rem;
            max-height: 4rem;
            min-width: 14rem;
          "
          alt="logo"
        />
      </div>
    </div>
    <div class="invoice">
      <div class="flex justify-center" v-if="tokenNo !== '-'">
        <div class="token mr-1">
          <p style="font-size: 14pt; font-weight: 600;">
            {{ tokenServiceHeader }}
          </p>
          <p style="font-size: 12pt; font-weight: 600;">
            TOKEN NO : <strong>{{ tokenNo }}</strong>
          </p>
        </div>
      </div>
      <div class="details flex space-between">
        <div class="user-details">
          <h2>Name: {{ userData.name }}</h2>
          <h2>F/H Name: {{ userData.fatherHusband }}</h2>
          <h2 v-if="userData.refferedTo">
            Referred to: {{ userData.refferedTo }}
          </h2>
          <h2 v-if="!userData.refferedTo && userData.referredBy">
            Referred by: {{ userData.referredBy }}
          </h2>
          <h2 v-if="userData.comment">Comment: {{ userData.comment }}</h2>
        </div>
        <div class="user-details">
          <h2>Age: {{ userData.age ? userData.age : "" }} / {{ gender }}</h2>
          <h2 v-show="invoiceNo">Invoice No: {{ invoiceNo }}</h2>
          <h2 v-if="userData.refferedTo && userData.referredBy">
            Referred by: {{ userData.referredBy }}
          </h2>
        </div>
        <div class="user-details">
          <h2>MR: {{ userData.mrNo && userData.mrNo.substring(3) }}</h2>
          <h2 v-if="selectedPanel">Panel: {{ selectedPanel }}</h2>
          <h2>
            Bill Date:
            {{ printInvoiceType ? created_at : currentDate() }}
          </h2>
          <h2 v-if="userData.refferedTo && userData.referredBy">
            Status: {{ invoiceStatus === 1 ? "Paid" : "Unpaid" }}
          </h2>
          <h2 v-if="invoiceType === 'rePrintInvoice'">
            Status:
            {{
              rows && rows.length > 0 && rows[0].invoice_status === 1
                ? "Paid"
                : "Unpaid"
            }}
          </h2>
        </div>
      </div>
      <div class="invoiceTable">
        <template>
          <div>
            <div :class="`table`">
              <div class="table-wrrapper">
                <table>
                  <thead>
                    <tr>
                      <th
                        v-for="(item, idx) in serviceColumns"
                        :key="`col-${item.column}-${idx}`"
                      >
                        <div class="table-header">
                          <span class="label">{{
                            item.isVisible ? item.label : ""
                          }}</span>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(row, rIdx) in displayedRows" :key="rIdx">
                      <td
                        v-for="(col, idx) in serviceColumns"
                        :key="`col-${row[col.column]}-${idx}`"
                        :style="`width: ${col.width}px;`"
                      >
                        <slot
                          v-if="col.column == 'action'"
                          name="action"
                          :actions="row"
                        ></slot>
                        <slot
                          v-else-if="col.column == 'service'"
                          name="service"
                          :services="row"
                        ></slot>
                        <slot
                          v-else-if="col.column == 'price'"
                          name="price"
                          :services="row"
                          ><span>{{ row.price }}</span></slot
                        >
                        <slot
                          v-else-if="col.column == 'quantity'"
                          name="quantity"
                          :quantity="row"
                        ></slot>
                        <slot
                          v-else-if="
                            col.column == 'discount' && col.isVisible == true
                          "
                          name="discount"
                          :discount="row"
                        ></slot>
                        <slot
                          v-else-if="col.column == 'discountPercentage'"
                          name="discountPercentage"
                          :discountPercentage="row"
                        ></slot>
                        <span v-else style="border: none;">{{
                          col.column == "serial" ? rIdx + 1 : row[col.column]
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="total">
        <div
          v-if="discount && discount != 0"
          class="discount flex align-center justify-end"
        >
          <h2 class="mr-2">Discount (PKR)</h2>
          <h2>{{ discount.toLocaleString() }}</h2>
        </div>
        <div class="discount flex align-center justify-end">
          <h2 class="mr-2">Total (PKR)</h2>
          <h2>{{ total.toLocaleString() }}</h2>
        </div>
      </div>
      <div class="footer">
        <p class="text-center">
          <!-- رپورٹ تیار ہوتے ہی آپ کے موبائل نمبر پر اطلاع دی جاے گی ۔ -->
        </p>
        <p class="text-center note">
          <!-- A text message will be sent on your registered mobile number when
          report is ready. You can view and download report or visit with
          original receipt to collect the report. -->
        </p>
        <p class="text-center">
          Printed by {{ userInfo.full_name }} on
          {{ printedOn }}
        </p>
        <p class="text-center">Powered by uConnect Technologies</p>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { getBranchLogo } from "../utils/helpers";
export default {
  components: {},
  data() {
    return {
      bussinessLogoUrl: "",
      branchLogo: null
    };
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
      require: true
    },
    discount: {
      type: [String, Number]
    },
    total: {
      type: [String, Number]
    },
    refferedTo: {
      type: String
    },
    refferedBy: {
      type: String
    },
    searchResult: {
      type: Object
    },
    registerPatient: {
      type: Object
    },
    invoiceNo: {
      type: [Number, String]
    },
    id: {
      type: String,
      default: "printTable"
    },
    isOther: {
      type: String,
      default: ""
    },
    invoiceStatus: {
      type: Number || String,
      default: 0
    },
    comment: {
      type: String,
      default: ""
    },
    invoiceType: {
      type: String,
      default: "",
      require: true
    },
    patientGender: {
      default: "",
      require: true
    },
    selectedPanel: {
      default: "",
      require: true
    }
  },
  methods: {
    ...mapActions({
      settingsList: "bussiness/settingsList",
      fetchBranch: "expenses/fetchBranch"
    }),
    currentDate() {
      return moment().format("DD/MM/YYYY, h:mm:ss A");
    }
  },
  computed: {
    ...mapGetters({
      tokens: "receptionist/tokens",
      settings: "bussiness/settings",
      selectedBranch: "expenses/selectedBranch",
      userInfo: "auth/userInfo",
      fetchUserBranch: "expenses/fetchUserBranch"
    }),
    displayedRows() {
      if (this.rows.length === 0) {
        // Return a placeholder row to force table rendering
        return [{ placeholder: true }];
      }
      return this.rows;
    },
    userData() {
      const patient = this.registerPatient || {};
      const searchItems = this.searchResult || {};
      const user = {
        name: searchItems?.name || patient?.name,
        mrNo: searchItems?.mr_no || patient?.mr_no,
        age: searchItems?.age || patient?.age,
        referredBy:
          this.refferedBy || searchItems?.referredBy || patient?.referredBy,
        fatherHusband:
          searchItems?.fatherOrHusbandName || patient?.fatherOrHusbandName,
        refferedTo: this?.refferedTo || searchItems?.user?.employ?.full_name,
        comment: this.comment
      };
      return user;
    },
    created_at() {
      return moment(this.rows[0]?.createdDate).format("DD/MM/YYYY, h:mm:ss A");
    },
    gender() {
      return this.patientGender;
    },
    printedOn() {
      return moment().format("dddd, MMMM Do, YYYY");
    },
    isDiscount() {
      return this.rows.filter(item => item.discountValue).length;
    },
    discountPercentage() {
      return this.rows.filter(item => item.discountPercentageValue).length;
    },
    isQuantity() {
      return this.rows.filter(item => item.quantityNumber).length;
    },
    isVisible() {
      return this?.isOther === "Radiology";
    },
    printInvoiceType() {
      return this.invoiceType === "laterInvoice" ? true : false;
    },
    serviceColumns() {
      return [
        { column: "serial", label: "#", width: "60", isVisible: true },
        { column: "name", label: "Service Charges", isVisible: true },
        { column: "price", label: "Price", isVisible: true },

        {
          column: "discountValue",
          label: "Discount",
          isVisible: this.isDiscount
        },
        {
          column: "quantityNumber",
          label: "Quantity",
          isVisible: this.isQuantity
        },
        { column: "subtotal", label: "Sub Total", isVisible: true }
      ];
    },
    getBranchUrl() {
      return !this.selectedBranch.length
        ? this.branchLogo
        : this.selectedBranch;
    },
    uniqueTokens() {
      const uniqueServices = [];
      const tokenMap = {};

      this.tokens.forEach(token => {
        if (!tokenMap[token.serviceHead]) {
          tokenMap[token.serviceHead] = true;
          uniqueServices.push(token);
        }
      });

      return uniqueServices;
    },
    uniqueRows() {
      const uniqueServices = [];
      const rowMap = {};

      this.rows.forEach(row => {
        if (!rowMap[row.service]) {
          rowMap[row.service] = true;
          uniqueServices.push(row);
        }
      });

      return uniqueServices;
    },
    tokenServiceHeader() {
      const fromTokens = this.uniqueTokens?.[0]?.serviceHead;
      const fromRows = this.uniqueRows?.[0]?.service;
      return fromTokens || fromRows || "TOKEN";
    },
    tokenNo() {
      const fromTokens =
        this.uniqueTokens?.[0]?.visits ??
        this.uniqueTokens?.[0]?.token ??
        this.uniqueTokens?.[0]?.tokenNo ??
        this.uniqueTokens?.[0]?.value;
      const fromRows =
        this.uniqueRows?.[0]?.token ??
        this.rows?.[0]?.token ??
        this.rows?.[0]?.visits ??
        this.rows?.[0]?.tokenNo;
      const token = fromTokens ?? fromRows;
      return token !== undefined && token !== null && token !== ""
        ? token
        : "-";
    }
  },
  async mounted() {
    await this.fetchBranch();
    this.branchLogo = getBranchLogo(
      this.fetchUserBranch,
      this.userInfo?.userBranchId
    );
  }
};
</script>

<style>
.table {
  position: relative;
  /* min-height: 10px; */
  /* max-height: 600px; */
  background: #ffffff;
  /* overflow: auto; */
  z-index: 1;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}

/* Fixed Headers */

th {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}

th[scope="row"] {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 1;
}

th[scope="row"] {
  vertical-align: top;
  color: inherit;
  background-color: inherit;
}

th:not([scope="row"]) {
  left: 0;
  z-index: 3;
  background: #fcfcfc;
}

.table.loading {
  overflow: hidden;
  height: 200px;
}

.table .loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 20px;
}

.table table {
  width: 100%;
  position: relative;
  border-collapse: collapse;
}

.table table thead,
tr {
  /* border-color: #ebebeb;
  border-bottom: 1px solid; */
}

.table tbody tr {
  border-bottom: 1px solid #ebebeb;
}

.table tbody tr td {
  border-top: 1px solid #ebebeb !important;
}

.table table thead tr th {
  top: -1px;
}

.table .table-header {
  display: flex;
  align-items: center;
}

.table table thead tr th:first-child {
  justify-content: center;
  display: flex;
  padding-bottom: 20px;
}

.table table thead tr th .label {
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  color: #141414;
}

.table table tr th {
  position: sticky;
  top: -1px;
  box-shadow: 0 0 2px -1px #ebebeb;
  z-index: 3000;
  left: 0;
  margin: 0;
  padding: 0.9rem;
  font-size: 12px;
  cursor: pointer;
  text-align: left;
  white-space: nowrap;
}

.table table tr td {
  padding: 0.9rem;
}

.table table tr td:first-child {
  text-align: center;
}

.table table tr td span {
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  color: #272727;
}

.print-table {
  display: none !important;
  margin: 0 !important;
  padding: 0 !important;
  margin-top: 1rem !important;
  width: 100%;
}

@media print {
  .print-table {
    margin: 0 !important;
    padding: 0 !important;
    margin-top: 1rem !important;
    display: block !important;
  }

  body {
    font-family: "Nunito Sans", sans-serif;
    font-size: 14pt;
    margin: 0 !important;
    padding: 0 !important;
  }

  .header {
    border-bottom: 1px solid hsl(0, 0%, 82%);
  }

  .header .logo {
    margin-bottom: 14pt;
  }

  .discount h2 {
    margin: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 8pt;
    letter-spacing: 0.05em;
    text-transform: capitalize;
    color: #141414;
  }

  .token p {
    font-size: 8pt;
    margin: 0;
    margin-top: 10px;
  }

  .token span {
    font-style: normal;
    font-weight: 500 !important;
    font-size: 8pt !important;
    line-height: 35px;
    color: #3e3e3e;
  }

  .footer p {
    margin: 0;
    font-size: 8pt;
  }

  .footer .note {
    font-size: 8pt;
  }

  #printTable h2,
  h3,
  h4 {
    margin: 0;
    padding: 0;
    font-family: "Nunito Sans", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 10pt;
    line-height: 25px;
    color: #000000;
  }

  .details {
    padding: 10px 0 10px 0;
  }

  .details h2 {
    margin-top: -8px;
  }

  /** Setting margins */

  @page {
    margin: 2cm;
  }

  .table span {
    font-size: 8pt !important;
  }

  .table {
    border-bottom: none;
    min-height: 0;
  }

  .table tbody tr {
    border-bottom: 1px solid #ebebeb !important;
  }

  .table tbody tr {
    border-top: 1px solid #ebebeb !important;
  }

  .table table tr th:first-child {
    padding-bottom: none;
  }

  .table table tr th {
    padding: 0 !important;
  }

  .table table tr td {
    padding: 0 !important;
  }
}

.table {
  position: relative;
  /* min-height: 10px; */
  /* max-height: 600px; */
  background: #ffffff;
  /* overflow: auto; */
  z-index: 1;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}

/* Fixed Headers */

th {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}

th[scope="row"] {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  z-index: 1;
}

th[scope="row"] {
  vertical-align: top;
  color: inherit;
  background-color: inherit;
}

th:not([scope="row"]) {
  left: 0;
  z-index: 3;
  background: #fcfcfc;
}

.table.loading {
  overflow: hidden;
  height: 200px;
}

.table .loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 20px;
}

.table table {
  width: 100%;
  position: relative;
  border-collapse: collapse;
}

.table table thead,
tr {
  /* border-color: #ebebeb;
  border-bottom: 1px solid; */
}

.table tbody tr {
  border-bottom: 1px solid #ebebeb;
}

.table tbody tr td {
  border-top: 1px solid #ebebeb !important;
}

.table table thead tr th {
  top: -1px;
}

.table .table-header {
  display: flex;
  align-items: center;
}

.table table thead tr th:first-child {
  justify-content: center;
  display: flex;
  padding-bottom: 20px;
}

.table table thead tr th .label {
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  color: #141414;
}

.table table tr th {
  position: sticky;
  top: -1px;
  box-shadow: 0 0 2px -1px #ebebeb;
  z-index: 3000;
  left: 0;
  margin: 0;
  padding: 0.9rem;
  font-size: 12px;
  cursor: pointer;
  text-align: left;
  white-space: nowrap;
}

.table table tr td {
  padding: 0.9rem;
}

.table table tr td:first-child {
  text-align: center;
}

.table table tr td span {
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  color: #272727;
}
</style>
